module.exports = __webpack_public_path__ + "static/media/logo1.d7948dfb.png";